var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHangman2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    width: 298.232,
    height: 291,
    viewBox: "0 0 298.232 291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691",
    transform: "translate(-219 -183)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2974",
    "data-name": "Rectangle 2974",
    width: 5,
    height: 61.733,
    transform: "translate(310.627 183.247) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2966",
    "data-name": "Rectangle 2966",
    width: 5,
    height: 298.232,
    rx: 2.5,
    transform: "translate(517.232 469) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    transform: "translate(423.5 228.247)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2987",
    "data-name": "Rectangle 2987",
    width: 5,
    height: 289,
    rx: 2.5,
    transform: "translate(267 183)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2988",
    "data-name": "Rectangle 2988",
    width: 187,
    height: 5,
    rx: 2.5,
    transform: "translate(267 183)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2989",
    "data-name": "Rectangle 2989",
    width: 5,
    height: 49,
    rx: 2.5,
    transform: "translate(449 184)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangman2);
export default __webpack_public_path__ + "static/media/hangman-2.8b1c2e1cc264c28d7bd21486fe05ef77.svg";
export { ForwardRef as ReactComponent };